export const networkDelay = <T>(t: T) =>
  new Promise((resolve) =>
    // This uses a longer timeout for storybook so it feels more realistic, but
    // the tests just don't need to wait that long. We just need to make sure it
    // delays to the next tick.
    setTimeout(
      () => resolve(t),
      typeof jest === 'undefined' ? Math.floor(Math.random() * 200) : 1,
    ),
  );
export function wrapNamespace<T extends object>(namespace: T): T {
  const done: Partial<Record<keyof T, boolean>> = {};

  return new Proxy(namespace, {
    get(target, k, receiver) {
      const propKey = k as keyof T;
      const targetValue = Reflect.get(target, propKey, receiver);
      if (typeof targetValue === 'function' && done[propKey] !== true) {
        const applyWithDelay = (...args: any[]) => {
          const value = targetValue.apply(target, args);
          if (value && typeof value === 'object' && 'then' in value)
            return Promise.resolve(value).then(networkDelay);
          return value;
        };
        done[propKey] = true;
        // @ts-expect-error
        target[propKey] = applyWithDelay;
        return applyWithDelay;
      }
      return targetValue;
    },
  });
}
